// extracted by mini-css-extract-plugin
export default {"base":"o0_Qt","icon":"_9WAj"};